export default __webpack_public_path__ + "6e4705121572b544454a6a0354e49f35.png";